let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("luWdK")).then(() => parcelRequire('84wGJ'));